// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#candidateRow td {
    color: black;
}
.table th{
    cursor: pointer;
    white-space: nowrap;
}
.table td,.table span{
    white-space: nowrap;
  }`, "",{"version":3,"sources":["webpack://./src/app/saved-candidates/saved-candidates.component.css"],"names":[],"mappings":";AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,mBAAmB;EACrB","sourcesContent":["\n#candidateRow td {\n    color: black;\n}\n.table th{\n    cursor: pointer;\n    white-space: nowrap;\n}\n.table td,.table span{\n    white-space: nowrap;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
